/** Build the canonical app URL for a given path. Uses the current origin
 *  so links work across dev/staging/prod. */
export function appUrl(path: string): string {
  const base = typeof window !== "undefined" ? window.location.origin : "";
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalized}`;
}

/** Build the shareable URL for a release's editor page. */
export function releaseUrl(releaseId: string): string {
  return appUrl(`/releases/${releaseId}`);
}

/** Build the shareable URL for a feature's editor page. */
export function featureUrl(featureId: string): string {
  return appUrl(`/features/${featureId}`);
}

/** Build the shareable URL that opens a release in the Timeline drawer.
 *  Preserves any existing search params (like the filter). */
export function releaseDrawerUrl(releaseId: string): string {
  if (typeof window === "undefined") return appUrl(`/?release=${releaseId}`);
  const url = new URL(window.location.href);
  url.pathname = "/";
  url.searchParams.delete("feature");
  url.searchParams.set("release", releaseId);
  return url.toString();
}

/** Build the shareable URL that opens a feature in the Timeline drawer.
 *  Preserves any existing search params (like the filter). */
export function featureDrawerUrl(featureId: string): string {
  if (typeof window === "undefined") return appUrl(`/?feature=${featureId}`);
  const url = new URL(window.location.href);
  url.pathname = "/";
  url.searchParams.delete("release");
  url.searchParams.set("feature", featureId);
  return url.toString();
}
